// extracted by mini-css-extract-plugin
export default {"slider":"imageSlider_slider__YG2Ij","emptyBlok":"imageSlider_emptyBlok__ifX7b"};